<template>
  <div class="pa-page pa-page-home">
    <PreRegistrationMessage />
    <CharacterStatusIndex />
    
    <LoginStampCard />

    <PAStoryListWidget />

    <HomeCreditField />

    <StoryBook />
  </div>
</template>

<script>
import PreRegistrationMessage from '@/components/Pages/Home/PreRegistrationMessage/PreRegistrationMessage.vue'
import CharacterStatusIndex   from '@/components/Pages/Home/CharacterStatusIndex/CharacterStatusIndex.vue'
import PAStoryListWidget      from '@/components/Pages/Home/PAStoryListWidget/PAStoryListWidget.vue'
import LoginStampCard         from '@/components/Pages/Home/LoginStampCard/LoginStampCard.vue'
import HomeCreditField        from '@/components/Pages/Home/HomeCreditField/HomeCreditField.vue'

import StoryBook              from '@/components/Parts/StoryBook/StoryBook.vue'

import LoginedPageMixins          from '@/mixins/LoginedPageMixins'
import FetchApplicationDataMixins from '@/mixins/FetchApplicationDataMixins'

import {GetMe}  from '@/graphql/queries/User.graphql'

export default {
  mixins : [
    LoginedPageMixins,
    FetchApplicationDataMixins
  ],

  components : {
    PreRegistrationMessage,
    CharacterStatusIndex,

    PAStoryListWidget,

    StoryBook,

    LoginStampCard,

    HomeCreditField
  },

  apollo : {
    me: {
      query: GetMe,
      error(err){
        const simpleErrorSet = this.getApolloSimpleErrorFromApolloError(err);
        
        this.apolloResultValidation(simpleErrorSet);
      },
    }
  },

  async mounted(){
    this.$on('mountedPage', () => {
      if((this.me.name === null) && (this.me.primaryCharacter.name === null)){
        this.$router.push({name: 'registration.userIdConfirmation'});
      }

      // 定期的に更新が必要なデータを取得します。
      this.fetchApplicationData();
    });

    await this.initializePage({
      title : 'ホーム'
    });
  }
}
</script>

<style lang="scss">
.pa-page{
  &-home{
    padding-bottom:1.5rem;
  }
}
</style>